import { render, staticRenderFns } from "./GroupApply.vue?vue&type=template&id=0fc50f2a&scoped=true"
import script from "./GroupApply.vue?vue&type=script&lang=js"
export * from "./GroupApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc50f2a",
  null
  
)

export default component.exports